import { types } from "mobx-state-tree";

export default types.model("Contact", {
  id: types.identifier,
  email: types.string,
  name: types.string
});
